import { ShortcodeContext } from '..';

export const applyYear = ({
  context,
}: {
  context: ShortcodeContext;
}): string => {
  const currentYear = new Date().getFullYear();
  context.text = context.text.replace(
    /\[year\]/g,
    `<span class="year">${currentYear}</span>`,
  );
  return context.text;
};
